export default "__VITE_ASSET__DOO2x$nc__"